import { Injectable, OnInit } from '@angular/core';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick, NgwScore } from '../app/classes/NgwGame';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {MyGlobals} from '../app/globals';

import 'rxjs/add/operator/map';

import * as moment from 'moment';
declare var require: any;


const localforage: LocalForage = require("localforage");

@Injectable()
export class NgwService {
    public currentGame:NgwGame = null;
    ngwStore: LocalForage = null;
    myGlobals:MyGlobals;


    players: NgwPlayer[];
    games: NgwGame[];

    // public db: AngularIndexedDB = null;

    constructor(public http: Http) {

        this.myGlobals = new MyGlobals();

        this.ngwStore = localforage.createInstance({
            name: "ngw"
        });

        this.ngwStore.getItem("players").then((players: any) => {
            this.players = [];
            if (players)
                this.players = players.players

        });

        this.ngwStore.getItem("games").then((games: any) => {
            this.games = [];
            if (games)
                this.games = games.games;
            this.setLastGameToCurrent()
        });

        /*
        this.db = new AngularIndexedDB('ngwDb', dbVersion);
        
        
        this.db.createStore(dbVersion, (evt) => {
           if(dbVersion <= 1)
            {
                let objectStore = evt.currentTarget.result.createObjectStore(
                    'ngwPlayers', { keyPath: "id", autoIncrement: true });
            }

            if(dbVersion <= 3) 
            {
                let objectStore = evt.currentTarget.result.createObjectStore(
                    'ngwGames', { keyPath: "id", autoIncrement: true });
            }
        }).then(() => {
            this.setLastGameToCurrent();
        });
        */
    }

    getPlayers() {
        //return this.ngwStore.getItem("players")
        let promise = new Promise((resolve, reject) => {
            resolve(this.players);
        });

        return promise;


    }

    savePlayers() {
        this.ngwStore.setItem("players", { players: this.players });
    }

    addPlayer(player: NgwPlayer) {
        if(!this.players.find((lPlayer) => lPlayer.name == player.name && !lPlayer.deleted))
        {
            this.players.push(player);            
            this.savePlayers();
        }
        //return this.db.add("ngwPlayers", player);
    }


    createNewGame(nhlGame) {


        let newGame = new NgwGame();
        newGame.id = 1;
        newGame.gameDate = nhlGame.gameDate;
        newGame.away = new NgwTeam();
        newGame.away.abbreviation = nhlGame.teams.away.team.abbreviation
        newGame.away.id = nhlGame.teams.away.team.id
        newGame.away.teamName = nhlGame.teams.away.team.teamName
        newGame.away.locationName = nhlGame.teams.away.team.locationName

        newGame.home = new NgwTeam();
        newGame.home.abbreviation = nhlGame.teams.home.team.abbreviation
        newGame.home.id = nhlGame.teams.home.team.id
        newGame.home.teamName = nhlGame.teams.home.team.teamName
        newGame.home.locationName = nhlGame.teams.home.team.locationName


        newGame.nhlGame = nhlGame;

        newGame.players = []
        newGame.rounds = [];

        let currScore = {
            awayScore: 0,
            homeScore: 0
        };
        let firstRound: NgwRound = this.createNewRound(1, 0, currScore.awayScore, currScore.homeScore);
        newGame.rounds.push(firstRound);

        this.games.push(newGame);
        this.currentGame = newGame;
        this.saveGames();
        this.getScore(nhlGame).then((score: any) => {
            firstRound.startingAwayScore = score.awayScore;
            firstRound.startingHomeScore = score.homeScore;
            newGame.currScore = score;
            //tb testing
//firstRound.startingAwayScore = 0;
  //          firstRound.startingHomeScore = 0;

        });


        this.loadTeams().subscribe(data => {
            console.log("Data", data)
            for (var i = 0; i < data.teams.length; i++) {
                var val = data.teams[i];
                if (val.id == newGame.away.id)
                    newGame.away.team = val;
                else if (val.id == newGame.home.id)
                    newGame.home.team = val;
            }

            //now filter out goalies:
            newGame.away.team.roster.roster = newGame.away.team.roster.roster.filter(this.playerFilter).sort(this.playerSort)
            newGame.home.team.roster.roster = newGame.home.team.roster.roster.filter(this.playerFilter).sort(this.playerSort)
            this.updateCurrGame();
        });


    }

    playerFilter(player) {
        return player.person.primaryPosition.abbreviation != "G"
    }

    playerSort(a, b) {
        var aPts = -999
        var bPts = -999
        try {
            aPts = a.person.stats[0].splits[0].stat.points
        }
        catch (err) { }

        try {
            bPts = b.person.stats[0].splits[0].stat.points
        }
        catch (err) { }

        if (aPts < bPts)
            return 1
        if (bPts < aPts)
            return -1;

        return 0;
    }



    loadTeams() {
        console.log("requesting")
        var url = "https://statsapi.web.nhl.com/api/v1/teams?site=en_nhl&teamId=" + this.currentGame.away.id + "," + this.currentGame.home.id + "&expand=team.roster,team.stats,roster.person,person.stats&stats=statsSingleSeason";

        return this.http.get(url)
            .map((res: Response) => res.json());//.subscribe(data => {this.myText = data; console.log("Back", data)});;

    }

    getGamesWhenReady() {
        let promise = new Promise((resolve, reject) => {
            this.sleepTillGamesReady(resolve);
        });

        return promise;
    }

    sleepTillGamesReady(resolve) {
        if(this.games && this.games.length > 0)
        {
            resolve(this.games)
        }
        else
        {
            setTimeout(() => {
                this.sleepTillGamesReady(resolve);
            }, 1000);
        }
        
    }


    getScore(nhlGame: any) {

        let promise = new Promise((resolve, reject) => {

            let url = "http://statsapi.web.nhl.com/api/v1/schedule?startDate=" + moment().format("YYYY-MM-DD") + "&endDate=" + moment().format("YYYY-MM-DD") + "&expand=schedule.teams,schedule.linescore,schedule.broadcasts.all,schedule.ticket,schedule.game.content.media.epg,schedule.radioBroadcasts,schedule.game.seriesSummary,seriesSummary.series&leaderCategories=&leaderGameTypes=R&site=en_nhlCA&teamId=&gameType=&timecode=";
            url = "https://statsapi.web.nhl.com/api/v1/schedule?startDate=" + moment().add(this.myGlobals.daysToGoBack -2, 'd').format("YYYY-MM-DD") + "&endDate=" + moment().format("YYYY-MM-DD") + "&expand=schedule.linescore,schedule.scoringplays&leaderCategories=points,goals,assists&leaderGameTypes=R&site=en_nhl&teamId=&gameType=&timecode="
            this.http.get(url)
                .subscribe(response => {
                    let data: any = response.json();
                    let ourGame = null;

                    for (var i = 0; i < data.dates.length && !ourGame; i++) {
                        var currDate = data.dates[i];
                        for (var j = 0; j < currDate.games.length && !ourGame; j++) {
                            var currGame = currDate.games[j];
                            if (currGame.gamePk == nhlGame.gamePk)
                                ourGame = currGame;
                        }

                    }

                    let retVal: NgwScore = new NgwScore()
                    retVal.awayScore = 0;
                    retVal.homeScore = 0;

                    if (ourGame) {
                        retVal.status = ourGame.status.abstractGameState;
                        retVal.awayScore = ourGame.teams.away.score;
                        retVal.homeScore = ourGame.teams.home.score;
                        retVal.currentPeriod = ourGame.linescore.currentPeriod;
                        retVal.currentPeriodOrdinal = ourGame.linescore.currentPeriodOrdinal;
                        retVal.currentPeriodTimeRemaining = ourGame.linescore.currentPeriodTimeRemaining;
                        let totalScore = retVal.awayScore + retVal.homeScore;
                        //go find that goalscorers
                        retVal.goals = [];
                        for (var i = 0; i < ourGame.scoringPlays.length; i++) {
                            retVal.goals.push(ourGame.scoringPlays[i].players[0].player.id);
                        }

                    }

                    resolve(retVal);

                });
        });
        return promise;

    }



    createNewRound(roundNum: number, startingPot: number, startingAwayScore: number, startingHomeScore: number): NgwRound {
        let newRound = new NgwRound();
        newRound.num = roundNum;
        newRound.isScored = false;
        newRound.picks = [];
        newRound.startingAwayScore = startingAwayScore;
        newRound.startingHomeScore = startingHomeScore;
        newRound.startingPot = startingPot;
        newRound.totalPot = startingPot;
        newRound.carryOverToNextRoundPot = 0;
        this.shuffleRoundPlayers(newRound);

       console.log("NewRound", newRound)


        return newRound;
    }

    shuffleRoundPlayers(round:NgwRound)
    {
        if(round && this.currentGame)
            round.playerOrder = this.shuffle(this.currentGame.players);
    }



    shuffle(inArray) {
        var array = inArray.slice();
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    updateCurrGame(): void {
        //this.db.update('ngwGames', this.currentGame)
        this.saveGames();
    }

    saveGames(): void {
        this.ngwStore.setItem("games", { games: this.games });
    }

    setLastGameToCurrent(): void {
        if (!this.currentGame) {/*
            //go see if there's one in the db
            this.db.getAll('ngwGames').then((games) => {
                if(games.length > 0)
                    this.currentGame = games[games.length - 1];
            });;*/


            if (this.games.length > 0)
                this.currentGame = this.games[this.games.length - 1];

        }
    }

    generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    makePick(ngwPlayer: NgwPlayer, ngwRound: NgwRound, nhlPlayer: any) {
        let pick: NgwPick = new NgwPick();
        pick.isScored = false;
        pick.isWinner = false;
        pick.ngwPlayer = ngwPlayer;
        pick.nhlPlayer = nhlPlayer;
        ngwRound.totalPot++;
        ngwRound.picks.push(pick);
        this.updateCurrGame();

    }

    removePick(round: NgwRound, pick: NgwPick) {
        round.picks = round.picks.filter(obj => obj != pick);
        round.totalPot--;
        this.updateCurrGame();
    }
}


// WEBPACK FOOTER //
// ./src/app/ngw.service.ts